import VueRouter from 'vue-router';
import authRoutes from './authRoutes';
import commonRoutes from './commonRoutes';
import employeeRoutes from './employeeRoutes';
import employerRoutes from './employerRoutes';


export default function ({ store }) {
  const router = new VueRouter({
    hashbang: false,
    mode: 'history',
    routes: authRoutes
      .concat(employeeRoutes.map(r => ({
        meta: { onlyEmployee: true, requiresAuth: true },
        ...r,
      })))
      .concat(employerRoutes.map(r => ({
        meta: { onlyEmployer: true, requiresAuth: true },
        ...r,
      })))
      .concat(commonRoutes),
  });

  router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth) && !store.getters['auth/isLoggedIn']) {
      next({
        name: 'login',
        query: { redirect: to.fullPath },
      });
      return;
    }

    if (store.getters['auth/isLoggedIn']
      && !store.state.auth.user.email_verified
      && !to.matched.some(record => record.meta.acceptsUnverified)) {
      next({
        name: 'verify-email',
      });
      return;
    }

    if (
      store.getters['auth/isLoggedIn']
      && (
        (to.matched.some(record => record.meta.requiresNonAuth))
        || (
          to.matched.some(record => record.meta.onlyEmployer)
          && !store.getters['auth/isLoggedInEmployer']
        )
        || (
          to.matched.some(record => record.meta.onlyEmployee)
          && !store.getters['auth/isLoggedInEmployee']
        )
      )
    ) {
      next({
        name: 'home',
      });
      return;
    }

    next();
  });
  return router;
}
